import React from 'react';
import Shape from 'ati-ui-react/components/Shape';
import Skeleton from 'ati-ui-react/components/Skeleton';
import uuidv1 from 'uuid/v1';
import * as styles from './RatingFirmsLoading.scss';
import * as loadingHeaderStyles from '../RatingHeaderLoading/RatingHeaderLoading.scss';
import RatingHeaderLoading from '../RatingHeaderLoading';

const RatingFirmsLoading = ({ rowsCount }) => (
  <div>
    <div className={styles.firmsContainer}>
      <RatingHeaderLoading />
      <div className={styles.rowsContainer}>
        {
          [...Array(rowsCount)].map(() => (
            <Shape
              shadow
              className={styles.shape}
              key={uuidv1()}
            >
              <div className={loadingHeaderStyles.countContainer}>
                <div className={styles.position}>
                  <Skeleton className={styles.fakePosition} />
                </div>
                <div className={styles.firmInfo}>
                  <Skeleton className={styles.fakeFirmName1} />
                  <Skeleton className={styles.fakeFirmName2} />
                </div>
              </div>
              <div className={styles.icons}>
                <Skeleton className={styles.fakeIcons} />
                <Skeleton className={styles.fakeIcons} />
                <Skeleton className={styles.fakeIcons} />
                <Skeleton className={styles.fakeIcons} />
              </div>
              <div className={styles.recs}>
                <Skeleton className={styles.fakeRecs} />
              </div>
              <div className={styles.claims}>
                <Skeleton className={styles.fakeClaims} />
              </div>
            </Shape>
          ))
        }
      </div>
    </div>
  </div>
);

export default RatingFirmsLoading;
